var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3135692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.2064 0H40.889L36 6.41541V82.3996L40.889 88H66.2064C68.3015 88 70 86.3187 70 84.2445V3.75547C70 1.68128 68.3016 0 66.2064 0Z",
    fill: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.2375 0H64C66.0779 0 67.7625 1.68128 67.7625 3.75547V84.2445C67.7625 86.3185 66.0781 88 64 88H75.2375C77.3154 88 79 86.3187 79 84.2445V3.75547C79 1.68128 77.3154 0 75.2375 0Z",
    fill: "#E4F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41 0H13.8697C11.7326 0 10 1.68128 10 3.75547V84.2445C10 86.3185 11.7326 88 13.8697 88H41V0Z",
    fill: "#8FDDC1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.455 26C49.8957 26 47 23.0839 47 19.4999C47 15.9159 49.8957 13 53.455 13C54.7484 13 55.9967 13.3841 57.0648 14.1108C57.6568 14.5134 57.8126 15.3232 57.4126 15.9193C57.0128 16.5154 56.2086 16.672 55.6166 16.2695C54.9776 15.8349 54.2302 15.6052 53.455 15.6052C51.3223 15.6052 49.5871 17.3525 49.5871 19.4999C49.5871 21.6477 51.3223 23.3948 53.455 23.3948C54.2443 23.3948 54.9079 23.1586 55.4273 22.6927C55.5288 22.6017 55.6258 22.501 55.7152 22.3934C56.1739 21.8422 56.99 21.7697 57.5374 22.232C58.0849 22.6941 58.1567 23.5157 57.6978 24.0671C57.5279 24.2712 57.343 24.4633 57.148 24.6381C56.1545 25.529 54.8776 26 53.455 26Z",
    fill: "#EABC6B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M67.0796 26C66.4299 26 65.8484 25.5903 65.6306 24.9774L62.0723 14.73C61.8365 14.0503 62.1963 13.3085 62.876 13.0725C63.5557 12.8363 64.2981 13.1962 64.5342 13.8759L67.0572 21.1423L69.4601 13.9113C69.6871 13.2284 70.4243 12.8587 71.1074 13.0859C71.7903 13.3127 72.16 14.0498 71.9333 14.7325L68.5382 24.9492C68.3246 25.577 67.7438 25.9956 67.0899 26C67.0865 26 67.083 26 67.0796 26Z",
    fill: "#EABC6B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.5 29C30.7467 29 35 24.7467 35 19.5C35 14.2533 30.7467 10 25.5 10C20.2533 10 16 14.2533 16 19.5C16 24.7467 20.2533 29 25.5 29Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.5 22C22.4249 22 19.8297 23.9446 19 26.6089C20.715 28.094 22.9959 29 25.5 29C28.0041 29 30.285 28.094 32 26.6089C31.1703 23.9446 28.5751 22 25.5 22Z",
    fill: "#407093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.5 23C27.433 23 29 21.433 29 19.5C29 17.567 27.433 16 25.5 16C23.567 16 22 17.567 22 19.5C22 21.433 23.567 23 25.5 23Z",
    fill: "#365E7D"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.4156 48H17.5844C16.7093 48 16 47.2979 16 46.4317V42.5683C16 41.7021 16.7093 41 17.5844 41H33.4156C34.2907 41 35 41.7021 35 42.5683V46.4315C35 47.2977 34.2907 48 33.4156 48Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.4156 62H17.5844C16.7093 62 16 61.2979 16 60.4317V56.5684C16 55.7021 16.7093 55 17.5844 55H33.4156C34.2907 55 35 55.7021 35 56.5684V60.4317C35 61.2979 34.2907 62 33.4156 62Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.4156 76H17.5844C16.7093 76 16 75.2979 16 74.4317V70.5684C16 69.7021 16.7093 69 17.5844 69H33.4156C34.2907 69 35 69.7021 35 70.5684V74.4317C35 75.2979 34.2907 76 33.4156 76Z",
    fill: "#FFE07D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M71.6511 45H46.3491C45.6039 45 45 44.3285 45 43.5C45 42.6715 45.6039 42 46.3491 42H71.6509C72.396 42 73 42.6715 73 43.5C73.0002 44.3285 72.396 45 71.6511 45Z",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58.6816 53H46.3184C45.5902 53 45 52.3285 45 51.5C45 50.6715 45.5902 50 46.3184 50H58.6816C59.4098 50 60 50.6715 60 51.5C60 52.3285 59.4098 53 58.6816 53Z",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M71.6511 62H46.3491C45.6039 62 45 61.3285 45 60.5C45 59.6715 45.6039 59 46.3491 59H71.6509C72.396 59 73 59.6715 73 60.5C73.0002 61.3285 72.396 62 71.6511 62Z",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M71.6511 70H46.3491C45.6039 70 45 69.3285 45 68.5C45 67.6715 45.6039 67 46.3491 67H71.6509C72.396 67 73 67.6715 73 68.5C73 69.3285 72.396 70 71.6511 70Z",
    fill: "#407093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M58.6816 78H46.3184C45.5902 78 45 77.3285 45 76.5C45 75.6715 45.5902 75 46.3184 75H58.6816C59.4098 75 60 75.6715 60 76.5C60 77.3285 59.4098 78 58.6816 78Z",
    fill: "#407093"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M71.6511 37H46.3491C45.6039 37 45 36.3285 45 35.5C45 34.6715 45.6039 34 46.3491 34H71.6509C72.396 34 73 34.6715 73 35.5C73.0002 36.3285 72.396 37 71.6511 37Z",
    fill: "#407093"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateResume);
export default __webpack_public_path__ + "static/media/create-resume.7eeff1a63e94377cf1da38c32081da14.svg";
export { ForwardRef as ReactComponent };